import { Component, BaseTLDetailComponent, AxiosResponse, tlStore, tlISODateTimeToLocalNoSecondsString } from "../../../Infrastructure/CorBase/CoreBase";
import { DiscountService, DiscountFilter } from "../../../Services/AccBase/AllAccServices";

	export default abstract class  DiscountDetailBase extends BaseTLDetailComponent {

		discountService: DiscountService = new DiscountService();

		formData = {
			id: 0,
			discount: 0,
			validFrom: '',
			validTo: '',
			idTenant: Number(tlStore.state.idTenant),
			isDeleted: false,
			isSuccess: true,
			errorMessage:''
		};

		createdBase() {
			const currentDate = new Date();
			this.formData.validFrom = currentDate.toISOString().split('T')[0];
			const nextMonthDate = new Date();
			nextMonthDate.setMonth(currentDate.getMonth() + 1);

			// Nastavení validTo na datum o měsíc později ve formátu "YYYY-MM-DD"
			this.formData.validTo = nextMonthDate.toISOString().split('T')[0];
		}
		protected doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('discount.messageNew').toString(), this.$t('discount.messageEdit').toString(), this.$t('discount.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.discountService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.discount = response.data.discount;
			this.formData.validFrom = response.data.validFrom.substring(0, 10);
			this.formData.validTo = response.data.validTo.substring(0, 10);
			this.formData.idTenant = response.data.idTenant;
			this.formData.isDeleted = response.data.isDeleted;
			this.formData.isSuccess = response.data.isSuccess;
			this.formData.errorMessage = response.data.errorMessage;
		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			return this.discountService.update(this.objectId, this.formData)
		}

		protected createObject(): Promise<AxiosResponse<any>> {
			if (this.formData.validTo == '') {
				//@ts-ignore
				delete this.formData.validTo;
			}
			return this.discountService.create(this.formData);
		}

		saveBase() {
			if (this.styleFormNew) {
				this.discountService.create(this.formData).then(res => {
					if (res.data.isSuccess == false) {
						this.showAlertModalWithErrorMessage(res.data.errorMessage);
					}
					else {
						this.$store.commit("mainDataChanged", false);
						this.$store.commit("formIsInEditMode", false);
						this.goBack();
					}
				});
			}
			else {
				this.discountService.update(this.formData.id, this.formData).then(res => {
					if (res.data.isSuccess == false) {
						this.showAlertModalWithErrorMessage(res.data.errorMessage);
					}
					else {
						this.$store.commit("mainDataChanged", false);
						this.$store.commit("formIsInEditMode", false);
						this.goBack();
					}
				});
			}

		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.discountService.delete(this.objectId);
		}
		
		vIsMinDate: boolean = true;
		vIsMaxDate: boolean = true;
		vIsAmount: boolean = true;
	
		protected validateBase() {
			return !(this.vIsMinDate && this.vIsMaxDate && this.vIsAmount);
		}

		protected isCorrectMinDateBase(value: any) {
			this.vIsMinDate = value;
		}

		protected isCorrectMaxDateBase(value: any) {
			this.vIsMaxDate = value;
		}

		protected isAmountBase(value: any) {
			this.vIsAmount = value;
		}


	
	}
